import { render, staticRenderFns } from "./DeductionsType.vue?vue&type=template&id=5ce3a4a4&"
import script from "./DeductionsType.vue?vue&type=script&lang=js&"
export * from "./DeductionsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports